"use client"

import { useClientTranslation } from "@/modules/App/components/i18n/i18n.client"
import { fallbackLng, languages, Language } from "@/modules/App/components/i18n/settings"
import { ImageNoSSR } from "@/shared/components/ImageNoSSR/image-no-ssr"
import { SelectTrigger, Select, SelectContent, SelectItem, SelectValue } from "@dalmatech/ui"
import React, { useEffect, useState } from "react"

import * as styles from "./select-language.styled"

type FlagSourcesType = Record<Language, string>
const flagSources: FlagSourcesType = {
  en: "/img/illus/flag-gb.svg",
  de: "/img/illus/flag-de.svg",
}

const SelectLanguage = () => {
  const { i18n } = useClientTranslation()
  const [language, setLanguage] = useState(
    (i18n.resolvedLanguage as Language) ?? (fallbackLng as Language)
  )

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- sync language from the i18n resolved language (external source); setState-in-effect is the intended pattern here
    setLanguage(i18n.resolvedLanguage as Language)
  }, [i18n.resolvedLanguage])

  const handleChange = (value: string) => {
    void i18n.changeLanguage(value)
  }

  return (
    <div className={styles.root}>
      <Select onValueChange={handleChange} value={language}>
        <SelectTrigger className={styles.trigger}>
          <SelectValue>
            <ImageNoSSR
              src={flagSources[language]}
              width={20}
              height={20}
              alt={`${language} flag`}
            />
          </SelectValue>
        </SelectTrigger>
        <SelectContent className={styles.content}>
          {languages.map((lang) => (
            <SelectItem key={lang} value={lang} className={styles.item}>
              <ImageNoSSR src={flagSources[lang]} width={20} height={20} alt={`${language} flag`} />
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}

export default SelectLanguage
